import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Moment from 'react-moment';

import { formatNumber } from '../utils/number';
import withI18n from '../utils/withI18n';
import ChangeDegree from './ChangeDegree';
import { getLabel } from '../utils/i18n';
import { track, sensorEventTypes } from '../utils/sensors';

const { MARKET_ACTIVITY_CLICK } = sensorEventTypes;

const Container = styled.div`
  height: 48px;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #EAECEF;
  overflow: hidden;
  position: sticky;
  bottom: 0px;
`;

const Pane = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  height: 100%;
  padding: 0px 20px;
  position: relative;
`;

const Row = styled.div`
  color: #848E9C;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin-right: 60px;
  height: 100%;
  flex-shrink: 0;
  cursor: pointer;

  .pair {
    color: #212833;
    margin-right: 10px;
    font-size: 14px;
  }
  .change {
    margin-right: 4px;
  }
`;

const Amount = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 100%;
  text-align: right;
`;

const GreenAmount = styled(Amount)`
  flex-direction: row;
  justify-content: center;
  font-size: 100%;
  color: ${({ theme }) => theme.up};
`;
const RedAmount = styled(Amount)`
  flex-direction: row;
  justify-content: center;
  font-size: 100%;
  color: ${({ theme }) => theme.down};
`;
const Cycle = styled.div`
  font-size: 12px;
  color: #848E9C;
  padding: 0px 4px;
`;

const mapStateToProps = ({ JPushLists, locale }) => ({ JPushLists, locale });

type Props = {
  i18n: Object,
  JPushLists: Array<Object>,
  locale: string,
}

export default
@withI18n
@connect(mapStateToProps)
class RecentMarketBar extends React.PureComponent<Props> {
  _renderPair = item => `${item.pair.slice(0, item.pair.length - item.qa.length)}/${item.qa}`

  _renderChange = item => {
    const { type, change } = item;
    const _change = Number(change) * 100;

    if ((_change > 0 || _change < 0) && (type === 'AbnormalPrice' || type === 'PriceBreakthroughs')) {
      if (_change > 0) {
        return <GreenAmount>+{formatNumber(_change, 2)}%</GreenAmount>;
      }
      return <RedAmount>{formatNumber(_change, 2)}%</RedAmount>;
    }
    return null;
  }

  _renderDirection = item => {
    const degree = Number(item.degree);
    const direction = degree > 0 ? 'up' : 'down';
    const { type } = item;

    return (
      <ChangeDegree direction={direction} degree={Math.abs(degree)} type={type} />
    );
  }

  _renderTime = item => {
    const { type, desc } = item;
    const { i18n } = this.props;
    const change = Number(item.change) * 100;

    if ((change > 0 || change < 0) && type === 'AbnormalPrice') {
      return <Cycle>{getLabel('exchange-trade-In5Min', i18n)}</Cycle>;
    }
    if (type === 'PriceBreakthroughs') {
      return <Cycle>{desc}</Cycle>;
    }
    return null;
  }

  _handleRowClick = item => {
    const { locale } = this.props;
    const {
      pair, qa, type, degree,
    } = item;
    const ba = pair.slice(0, pair.length - qa.length);
    const symbol = `${ba}_${qa}`;
    track(MARKET_ACTIVITY_CLICK, { symbol, type, degree });
    window.open(`/${locale}/trade/${symbol}`);
  }

  _renderChildren = () => {
    const { JPushLists } = this.props;

    return JPushLists.slice(0, 10).map((item, idx) => (
      <Row key={idx} onClick={() => this._handleRowClick(item)}>
        <div className="pair">{this._renderPair(item)}</div>
        <div className="change">{this._renderChange(item)}</div>
        <div className="direction">{this._renderDirection(item)}</div>
        {this._renderTime(item)}
        <div className="time">
          <Moment element="time" format="HH:mm:ss">
            {Number(item.time)}
          </Moment>
        </div>
      </Row>
    ));
  }

  render() {
    return (
      <Container>
        <Pane>
          {this._renderChildren()}
        </Pane>
      </Container>
    );
  }
}
